import axios from "axios";
import store from "../store";
import { showToast } from "../store/slices/common";
import {
  deleteSessionData,
  deleteToken,
  getAccessToken,
} from "../utils/auth-token-utils/cookie";

const AxiosInstance = axios;

AxiosInstance.defaults.baseURL = process.env.REACT_APP_BASE_URL;

AxiosInstance.defaults.timeout = 360000;
AxiosInstance.defaults.timeoutErrorMessage = "timeout";

const dispatch = store.dispatch;

const getHeaderObj = (config, accessToken) => {
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_PASSWORD;
  const token = btoa(`${username}:${password}`);
  if (
    config.url === "/auth/admin-login" ||
    config.url === "/auth/signup" ||
    config.url === "/auth/forgot-password"
  ) {
    return {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    };
  } else if (
    [
      "/user",
      "/admin/setup-app",
      "/admin/send-push-notification",
      "/upload",
      "/admin/theme/import",
      "/admin/audio/create",
      "/admin/audio/update",
      "/rap/add-audio",
      "/rap/edit-audio",
    ].includes(config.url) &&
    (config.method === "post" ||
      (["/rap/edit-audio"].includes(config.url) && config.method === "put"))
  ) {
    return {
      accessToken: ` Bearer ${accessToken}`,
      Authorization: `Basic ${token}`,
      "Content-Type": "multipart/form-data",
    };
  } else
    return {
      accessToken: ` Bearer ${accessToken}`,
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    };
};

//  Request interceptor
AxiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();

    config.headers = getHeaderObj(config, accessToken);
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//  Response interceptor
AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    const is401 = error?.response?.status === 401;
    const accessToken = getAccessToken();
    const requestUrl = error?.config?.url || error?.request?.responseURL || "";

    // Auth endpoints: don't treat 401 as session expiry (e.g. wrong credentials on login)
    const isAuthEndpoint = [
      "/auth/admin-login",
      "/auth/signup",
      "/auth/forgot-password",
    ].some((path) => requestUrl.includes(path));

    // Token expired / session invalid: clear auth and redirect immediately so we never re-render with cleared token (avoids blank screen)
    if (is401 && accessToken && !isAuthEndpoint) {
      deleteSessionData();
      deleteToken();
      window.location.replace("/?session_expired=1");
      return Promise.reject(error);
    }

    // File downloads reject with a Blob body. The caller reads that JSON.
    if (typeof Blob !== "undefined" && error?.response?.data instanceof Blob) {
      return Promise.reject(error);
    }

    if (error?.response?.data?.message || error?.message) {
      dispatch(
        showToast({
          color: "error",
          msg: error.response?.data?.message || error?.message,
        })
      );
    }

    return Promise.reject(error);
  }
);

export default AxiosInstance;
